import { isInsertLinkPending } from './isInsertLinkPending';

export function getPendingInsertLinkIds(allInsertLinks: string[]): string[] {
    return allInsertLinks.filter(linkId => isInsertLinkPending(linkId));
}
